<template>
  <CrudBase
    ref="peopleCrud"
    title="Pessoas"
    singular-title="Pessoa"
    api-endpoint="/api/v1/people"
    :columns="columns"
    :form-fields="formFields"
    :before-save="beforeSavePerson"
  >
    <template #filters="{ loadItems }">
      <div class="bg-white rounded-lg shadow-sm mb-6">
        <button
          type="button"
          class="w-full flex items-center justify-between px-6 py-4 border-b border-gray-200 hover:bg-gray-50 transition"
          @click="showFilters = !showFilters"
        >
          <span class="text-sm font-semibold text-gray-800">Filtros</span>
          <svg
            class="w-5 h-5 text-gray-500 transform transition-transform"
            :class="showFilters ? 'rotate-180' : ''"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
          </svg>
        </button>

        <div v-if="showFilters" class="px-6 py-4">
          <div class="flex flex-col lg:flex-row lg:items-end gap-4">
            <div class="flex flex-col sm:flex-row flex-1 min-w-0 gap-4">
              <div class="flex-1 min-w-0">
                <label class="block text-sm font-medium text-gray-700 mb-1">Nome</label>
                <input
                  v-model="filters.name"
                  type="text"
                  placeholder="Buscar por nome"
                  @keyup.enter="applyFilters(loadItems)"
                  class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                />
              </div>
              <div class="flex-1 min-w-0">
                <CitySelectAsync
                  v-model="filters.city_id"
                  :selected-label="filters.city_label"
                  clearable
                  label="Cidade"
                  placeholder="Digite para buscar cidade..."
                  @update:model-value="onFilterCityChange(loadItems)"
                  @city-picked="onFilterCityPicked"
                />
              </div>
              <div class="flex-1 min-w-0">
                <label class="block text-sm font-medium text-gray-700 mb-1">Perfil</label>
                <select
                  v-model="filters.role"
                  class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 bg-white"
                >
                  <option value="">Todos</option>
                  <option value="Owner">Proprietário</option>
                  <option value="Customer">Cliente</option>
                  <option value="Provider">Prestador Serviço</option>
                  <option value="Seller">Corretor</option>
                </select>
              </div>
            </div>
            <div class="flex justify-end lg:justify-start flex-shrink-0">
              <button
                @click="applyFilters(loadItems)"
                class="bg-indigo-600 text-white px-6 py-2 rounded-lg hover:bg-indigo-700 transition flex items-center justify-center space-x-2"
              >
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
                <span>Buscar</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template #form="{ form, errors }">
      <PersonForm ref="personForm" :form="form" block-label="Pessoa bloqueada" />
    </template>
  </CrudBase>
</template>

<script>
import CrudBase from './CrudBase.vue'
import PersonForm from './PersonForm.vue'
import CitySelectAsync from './CitySelectAsync.vue'

export default {
  components: {
    CrudBase,
    PersonForm,
    CitySelectAsync
  },

  data() {
    return {
      filters: {
        name: '',
        city_id: '',
        city_label: '',
        role: ''
      },
      showFilters: false,
      columns: [
        { key: 'name', label: 'Nome' },
        { key: 'document', label: 'CPF/CNPJ' },
        { key: 'phone', label: 'Telefone' },
        { key: 'email', label: 'E-mail' },
        {
          key: 'roles',
          label: 'Perfis',
          format: (value, item) => {
            const roles = []
            if (item.owner) roles.push('Proprietário')
            if (item.customer) roles.push('Cliente')
            if (item.agent) roles.push('Corretor')
            if (item.provider) roles.push('Prestador')
            return roles.join(', ')
          }
        },
        {
          key: 'city',
          label: 'Cidade',
          format: (value, item) => item.state ? `${value} - ${item.state}` : value
        }
      ],
      formFields: {
        name: '',
        document: '',
        rg: '',
        phone: '',
        email: '',
        profession: '',
        marital_status: '',
        nationality: 'Brasileiro',
        city_id: null,
        city_label: '',
        address: '',
        number: '',
        neighborhood: '',
        zip: '',
        note: '',
        blocked: false,
        owner: false,
        customer: false,
        provider: false,
        agent: false,
        contract_owner_rubric: null,
        contract_owner_signature: null,
        owner_contract_draw_url: null,
        owner_contract_draw_expires_at: null,
        owner_contract_draw_link_expired: false,
        owner_contract_draw_token_present: false
      }
    }
  },

  methods: {
    async beforeSavePerson() {
      const pf = this.$refs.personForm
      if (pf?.flushOwnerContractSignatures) await pf.flushOwnerContractSignatures()
      return true
    },
    onFilterCityPicked({ label }) {
      this.filters.city_label = label || ''
    },

    onFilterCityChange(loadItems) {
      if (this.filters.city_id === '' || this.filters.city_id == null) {
        this.filters.city_label = ''
      }
      this.applyFilters(loadItems)
    },

    applyFilters(loadItems) {
      const params = {}

      if (this.filters.name) {
        params.name = this.filters.name
      }
      if (this.filters.city_id !== '' && this.filters.city_id != null) {
        params.city_id = this.filters.city_id
      }
      if (this.filters.role) {
        params.role = this.filters.role
      }

      loadItems(params)
    }
  }
}
</script>
